import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { SITE, NAV_LINKS, SERVICES } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="relative text-white" style={{ backgroundColor: "#142a47" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-14 h-14 rounded-2xl bg-white ring-2 ring-white/20 p-1.5 flex items-center justify-center">
                <img src={SITE.logo} alt="Scharpf Logo" className="w-full h-full object-contain" />
              </div>
              <div>
                <div className="font-heading text-xl font-extrabold">Scharpf</div>
                <div className="text-[11px] tracking-[0.22em] uppercase text-white/60">
                  Haushaltsauflösungen
                </div>
              </div>
            </div>
            <p className="mt-5 text-white/70 leading-relaxed max-w-md">
              Ihr zuverlässiger Familienbetrieb für Haushaltsauflösungen, Entrümpelungen, Nachlassankäufe
              und Goldankauf in {SITE.region}.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href={`tel:${SITE.phoneE164}`}
                data-testid="footer-phone"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 hover:bg-white/15 transition-colors text-sm font-semibold"
              >
                <Phone className="w-4 h-4" style={{ color: "#7dd960" }} /> {SITE.phoneDisplay}
              </a>
              <a
                href={`https://wa.me/${SITE.whatsapp}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 hover:bg-white/15 transition-colors text-sm font-semibold"
              >
                <MessageCircle className="w-4 h-4" style={{ color: "#7dd960" }} /> WhatsApp
              </a>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 hover:bg-white/15 transition-colors text-sm font-semibold"
              >
                <Mail className="w-4 h-4" style={{ color: "#7dd960" }} /> E-Mail
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h5 className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-white/80">Navigation</h5>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-white/70 hover:text-white transition-colors text-sm">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h5 className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-white/80">Leistungen</h5>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`} className="text-white/70 hover:text-white transition-colors text-sm">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-start gap-2 text-white/70 text-sm">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: "#7dd960" }} />
              <div>
                <div className="text-white font-semibold">{SITE.addressStreet}</div>
                <div>{SITE.addressCity}</div>
                <div className="mt-3 text-xs uppercase tracking-[0.18em] text-white/60">Einsatzgebiet</div>
                <div className="mt-1">{SITE.serviceAreas.join(" · ")}</div>
                <div className="text-xs opacity-80">{SITE.serviceAreaNote}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} {SITE.fullName}. Alle Rechte vorbehalten.</div>
          <div className="flex items-center gap-5">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
            <Link to="/agb" className="hover:text-white transition-colors">AGB</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
